import { render } from "./MainHeader.vue?vue&type=template&id=27d298da"
import script from "./MainHeader.vue?vue&type=script&lang=js"
export * from "./MainHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MainHeader.vue"]])

export default __exports__